import { memo, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "sipli-fleet-core/utils/cn";

export interface CustomLinkProps extends HTMLAttributes<HTMLParagraphElement> {
  isLinkAvailable?: boolean;
  children?: ReactNode;
  className?: string;
}

function CustomLink({
  isLinkAvailable = true,
  children,
  className = "",
  ...restProps
}: CustomLinkProps) {
  return (
    <p
      className={cn("!mb-0", className, {
        "text-primary hover:underline font-semibold cursor-pointer":
          isLinkAvailable,
      })}
      {...restProps}
    >
      {children}
    </p>
  );
}

export default memo(CustomLink);
